module.exports = __webpack_public_path__ + "img/PDPA-4.7fd72b7b.png";